import { companyServiceHttpClient } from "src/common/CompanyServiceHttpClient";
import {
  CreateInstallPackage,
  ProductSkuContract,
  UploadComplete,
} from "src/models/installation";

export class InstallationManageServiceClient {
  //列表
  async list(v: number, sku: ProductSkuContract) {
    return await companyServiceHttpClient.get(
      `/v${v}/Installations/${sku}/publishedpackages`,
      {}
    );
  }

  //创建安装包
  async create(v: number, payload: CreateInstallPackage) {
    return await companyServiceHttpClient.post(
      `/v${v}/Installations`,
      payload,
      {}
    );
  }

  //获取上传地址
  async getUrl(v: number, id: string, fileName?: string, fileSize?: number) {
    return await companyServiceHttpClient.get(
      `/v${v}/Installations/${id}/uploadurl`,
      {
        params: {
          fileName: fileName,
          fileSize: fileSize,
        },
      }
    );
  }

  //通知上传完成
  async notice(v: number, id: string, payload: UploadComplete) {
    return await companyServiceHttpClient.patch(
      `/v${v}/Installations/${id}`,
      payload,
      {}
    );
  }

  //删除主文件
  async deleteMainFile(v: number, packageId: string) {
    return await companyServiceHttpClient.delete(
      `/v${v}/Installations/${packageId}/mainfile`,
      {}
    );
  }

  //删除额外文件
  async deleteExtFiles(v: number, packageId: string, fileName: string) {
    return await companyServiceHttpClient.delete(
      `/v${v}/Installations/${packageId}/extfiles/${fileName}`,
      {}
    );
  }

  //发布安装包
  async publishInstallation(v: number, packageId: string) {
    return await companyServiceHttpClient.patch(
      `/v${v}/Installations/${packageId}/publish`,
      {},
      {}
    );
  }

  //删除安装包
  async deleteInstallation(v: number, id: string) {
    return await companyServiceHttpClient.delete(
      `/v${v}/Installations/${id}`,
      {}
    );
  }
}
export const InstallationServiceClient = new InstallationManageServiceClient();
